export const WelcomeIndex = () => {
  window.location.href = "Welcome/index.html";
  return <></>;
};